export class Constants {
  public static EDGE_DETAILS_DIV_ID: string = 'edge-detail';
  public static INTERACTION_DETECTION_METHOD_LABEL: string = 'Interaction Detection Method';
  public static NO_DETECTION_METHODS_LABEL: string = 'No. of Detection Methods';
  public static MISCORE_LABEL: string = 'MIscore';
  public static INTERACTION_AC_LABEL: string = 'Ac';

  public static NODE_DETAILS_DIV_ID: string = 'node-detail';
  public static SPECIES_LABEL: string = 'Species';
  public static INTERACTOR_TYPE_LABEL: string = 'Type';
  public static INTERACTOR_NAME_LABEL: string = 'Name';
  public static INTERACTOR_AC_LABEL: string = 'Ac';
  public static INTERACTOR_ID_LABEL: string = 'Id';
}
